import { useEffect, useState } from 'react';
import { IoCloudDownload } from 'react-icons/io5';
import { Redirect, useParams } from 'react-router-dom';
import {
  downloadAditionalDocument,
  downloadFollowupRaport,
  downloadRaport
} from '../../network/raports';
import { ROUTES } from '../../routing/routes';
import CButton from '../button/button';
import styles from './litigation-document.module.scss';
import { typesDocuments } from '../../types/documents';
import { types } from 'util';
import { downloadLitigationDocument } from '../../network/litigii';

interface LitigationDocumentParams {
  id: any;
}

const LitigationDocument = () => {
  let { id } = useParams<LitigationDocumentParams>();

  return (
    <div className={styles.downloadCcrContainer}>
      <div className={styles.card}>
        <div className={styles.details}>
          <p className='body-dark faded'>Descarcare document</p>
          <div className={styles.list}>
            <CButton
              label={
                <p className={styles.download}>
                  Descarcă Documentul <IoCloudDownload />
                </p>
              }
              onClick={() => {
                downloadLitigationDocument(id, 'Document');
              }}
              type='button'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LitigationDocument;
